import type { FC } from 'react';
import React, { memo } from 'react';
import { BaseSelect as Select } from '@alfa-bank/site-form-utils/components/base-select';

import type { IAddressInputProps } from './models';
import { useAddressField } from './utils';
import { DEFAULT_DADATA_DELAY } from './config';

export const AddressInputDesktop: FC<IAddressInputProps> = memo(
    ({
        caption,
        className,
        dadataDelay = DEFAULT_DADATA_DELAY,
        error,
        forwardedRef,
        name,
        onBlur,
        onCancel,
        onChange,
        onFocus,
        onSelect,
        placeholder,
        success,
        value,
    }) => {
        const { handleCancel, handleChange, handleFocus, handleSelect, suggestions } =
            useAddressField({
                onSelect,
                onCancel,
                onChange,
                onFocus,
                value,
                dadataDelay,
                name,
            });

        return (
            <Select
                caption={caption}
                className={className}
                dataTestId="dc-form-delivery-address-input"
                error={error}
                forwardedRef={forwardedRef}
                name={name}
                onBlur={onBlur}
                onCancel={handleCancel}
                onChange={handleChange}
                onFocus={handleFocus}
                onSelect={handleSelect}
                options={suggestions}
                placeholder={placeholder}
                success={success}
                type="text"
                value={value}
            />
        );
    }
);
